import PropTypes from 'prop-types'

/**
 * A record number in tabular figures: "No. 0412". A number is zero-padded
 * to `digits`; a string is printed as given. Only for a record the database
 * numbers in a stable sequence; nothing in the app qualifies today.
 */
export default function ReceiptNo({
  n,
  digits = 4,
  tone = 'mute',
  className = '',
}) {
  const text = typeof n === 'number' ? String(n).padStart(digits, '0') : n
  return (
    <span
      className={`font-sans text-sm tabular whitespace-nowrap ${
        tone === 'ink' ? 'text-ink' : 'text-ink-mute'
      } ${className}`}
    >
      No.&nbsp;{text}
    </span>
  )
}

ReceiptNo.propTypes = {
  n: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  digits: PropTypes.number,
  // `ink` on amber or other tinted grounds, where the mute ink fails AA.
  tone: PropTypes.oneOf(['mute', 'ink']),
  className: PropTypes.string,
}
